import { useEffect, useState } from 'react';

const MOBILE_BREAKPOINT = 768;

/**
 * 모바일 여부를 감지하는 커스텀 훅 (MUI 의존성 없음)
 * matchMedia를 사용하여 breakpoint 변경 시에만 리렌더링
 */
export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    () => window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return isMobile;
}
